import loadable from '@loadable/component'

export const SearchBar = loadable(() => import('./SearchBar'))
export const ViewMore = loadable(() => import('./ViewMore'))
export type { SearchBarProps } from './SearchBar'
